import React from 'react';

import PropTypes from 'prop-types';

import { useLocalizedStringsContext } from '../../../../../context/LocalizedStringsContext';
import MultiSelect from './multiSelect';

const FilterByProduct = ({ filters, setFilters }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    ORDERS: { filterByProduct, ProductFilters }
  } = localizedStrings;
  return (
    <div>
      <MultiSelect
        label={filterByProduct}
        options={ProductFilters.map(item => ({
          label: item.text,
          value: item.value
        }))}
        value={filters.iotProductSelected}
        updateFilters={value => {
          setFilters({ ...filters, iotProductSelected: value });
        }}
      />
    </div>
  );
};

FilterByProduct.propTypes = {
  filters: PropTypes.objectOf(PropTypes.shape({})).isRequired,
  setFilters: PropTypes.func.isRequired
};

export default FilterByProduct;
